export default "__VITE_ASSET__D8nc5HTQ__"